import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

function DeleteConfirmModal({
  isOpen,
  toggle,
  connector,
  onConfirm,
  isLoading = false,
}) {
  const handleConfirm = () => {
    if (connector) {
      onConfirm(connector.id);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <ModalHeader toggle={toggle}>Delete Connector</ModalHeader>
      <ModalBody>
        <div className="text-center mb-3">
          <i className="fas fa-exclamation-triangle fa-3x text-warning"></i>
        </div>
        <p className="text-center">
          Are you sure you want to delete the connector{' '}
          <strong>{connector?.name}</strong>?
        </p>
        <div className="alert alert-warning">
          <small>
            <strong>Warning:</strong> This action cannot be undone. All cached
            data and sync history for this connector will be permanently
            removed.
          </small>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={isLoading}>
          Cancel
        </Button>
        <Button color="danger" onClick={handleConfirm} disabled={isLoading}>
          {isLoading ? 'Deleting...' : 'Delete Connector'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default DeleteConfirmModal;
